/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendGeneralSupportRequest
 */
export interface SendGeneralSupportRequest {
    /**
     * 
     * @type {string}
     * @memberof SendGeneralSupportRequest
     */
    description: string;
}

/**
 * Check if a given object implements the SendGeneralSupportRequest interface.
 */
export function instanceOfSendGeneralSupportRequest(value: object): value is SendGeneralSupportRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function SendGeneralSupportRequestFromJSON(json: any): SendGeneralSupportRequest {
    return SendGeneralSupportRequestFromJSONTyped(json, false);
}

export function SendGeneralSupportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendGeneralSupportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
    };
}

export function SendGeneralSupportRequestToJSON(json: any): SendGeneralSupportRequest {
    return SendGeneralSupportRequestToJSONTyped(json, false);
}

export function SendGeneralSupportRequestToJSONTyped(value?: SendGeneralSupportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

